export class Choice {
  constructor(
    public uid: string,
    public response: string,
    public checked: boolean,
    public icon: string,
    public fa_icon: string,
    public fa_color: string,
    public order: number
  ) { }
}

export class ChoiceMinimal {
  constructor(
    public uid: string,
    public response: string
  ) { }
}